'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './dashboard.routes';

export class DashboardComponent {
  /*@ngInject*/
  constructor(
    $http,
    $scope,
    Auth,
    $anchorScroll,
    $state,
    lookup,
    $window,
    $location,
    db,
    $timeout,
    theme
  ) {
    this.$http = $http;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$state = $state;
    this.$anchorScroll = $anchorScroll;
    this.$scope.currentSites = [];
    this.$window = $window;
    this.$location = $location;
    this.theme = theme;

    //Authentication and membership
    this.$scope.isLoggedIn = Auth.isLoggedInSync;
    this.$scope.isAdmin = Auth.isAdminSync;
    this.$scope.getCurrentUser = Auth.getCurrentUserSync;
    this.lookup = lookup;
    this.db = db;
    this.$scope.user = {};
  }

  $onInit() {
    if (this.db.getUser.length === 0) {
      /**
       * API call to get user Organization info. Resolves promise synchronously from logged in user query, and then queries organization info. Pulled from Sql Server
       * param: Organization_ID (from logged in user)
       */

      this.$http
        .get("/api/users/general")
        .then((response) => {
          this.$scope.user = response.data[0];
          this.db.setUser(this.$scope.user);
          console.log("response 1");
          //Set jurisdiction name
          this.$scope.jurisdiction = this.$scope.user.Organization_Name;
          this.$scope.role = this.$scope.user.role;
          // response.data[0].dashURL += "&param_jurisdiction=Oakland";
          console.log(response.data[0].dashURL);

          window.onload = this.loadIframe(this.$scope.user.dashURL);
          if (this.$scope.role !== "jurisdiction") {
            this.getJurisdictions();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      this.$scope.user = this.db.getUser();
      this.$scope.role = this.$scope.user.role;
      this.$scope.jurisdiction = this.$scope.user.Organization_Name;
      window.onload = this.loadIframe(this.$scope.user.dashURL);
      if (this.$scope.role !== "jurisdiction") {
        this.getJurisdictions();
      }
    }

    // Get list of my sites 
    this.getMyList();

    // Mode Iframe

    //Load theme functions
    this.theme.initTheme();

    // Get Hess Category layers from lookup service
    this.$scope.hessCategoryLayers = this.lookup.getHessCategoryLayers();

    window.addEventListener("message", function (e) {
      console.log(e);
      //Hide Filters
      const message = {
        type: "reportFilterPanelDisplay",
        togglePanel: true,
      };
      const iframe = window.document.querySelector("iframe");
      iframe.contentWindow.postMessage(message, "*");

      // always check the origin and make sure it is from app.mode.com
      if (e.origin === "https://app.mode.com") {
        if (e.data["type"] == "reportExportPaths") {
          const modeBaseUrl = e.origin;

          // CSV Export
          const csvExportUrl = e.data["report_csv_export_path"];
          var csvExportLink = $("#csv-export-link");
          csvExportLink.href = modeBaseUrl + csvExportUrl;
          console.log(csvExportLink);
        }
      }
    });
  }

  loadIframe(url) {
    // Embed Mode Iframe
    this.$scope.url = url;

    //Add url to iframe source
    document.getElementById("wleFrame").src = url;
    document.getElementById("wleFrame").onload = function () {
      //Hide the filter panel after loading
      setTimeout(function () {
        $("#loadingDiv").css("visibility", "hidden");
        toggleFilterPanel();
      }, 4000);
    };

    // Function to hide filter panel in mode iframe
    function toggleFilterPanel() {
      console.log("its running");
      const message = {
        type: "reportFilterPanelDisplay",
        showPanel: false,
      };
      const iframe = window.document.querySelector("iframe");
      iframe.contentWindow.postMessage(message, "*");
    }
  }

  loadAllCodes() {
    //Get list of zoning codes. If list doesn't exist in lookup service, request from server
    if (this.lookup.getZoningCodes().length > 0) {
      this.$scope.zn_codes = this.lookup.getZoningCodes();
    } else {
      this.$http
        .get("/api/data/parcels/zncodes/" + this.$scope.jurisdiction)
        .then((response) => {
          console.log("response 2");
          this.$scope.zn_codes = response.data;
          //Set zoning codes in lookup service
          this.lookup.setZoningCodes(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    //Get list of GP codes. If list doesn't exist in lookup service, request from server
    if (this.lookup.getGPCodes().length > 0) {
      this.$scope.gp_codes = this.lookup.getGPCodes();
    } else {
      this.$http
        .get("/api/data/parcels/gpcodes/" + this.$scope.jurisdiction)
        .then((response) => {
          console.log("response 3");
          this.$scope.gp_codes = response.data;
          console.log("gp_codes: ", this.$scope.gp_codes);
          //Set GP codes in lookup service
          this.lookup.setGPCodes(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    //Get list of use codes
    if (this.lookup.getUseCodes().length > 0) {
      this.$scope.use_codes = this.lookup.getUseCodes();
    } else {
      this.$http
        .get("/api/data/hess/parcel/uses/" + this.$scope.jurisdiction)
        .then((response) => {
          console.log("response 4");
          this.$scope.use_codes = response.data;
          this.lookup.setUseCodes(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  getMyList() {
    console.log('running get my list');
    this.$scope.listRecords = [];
    this.$http.get('/api/data/hess/parcel/list/' + this.$scope.jurisdiction)
      .then(response => {
        console.log("my sites: ", response.data);
        this.$scope.myListParcels = response.data;
        if (this.$scope.myListParcels.length > 0) {
          this.$scope.myListParcels.forEach(element => {
            this.$scope.listRecords.push(element.parcel_id);
          });
        }
        

      })
      .catch(err => {
        console.log(err);
      });
  }


  loadHessSummary() {
    this.$http
      .get("/api/data/hess")
      .then((response) => {
        console.log("response 5");
        this.$scope.hessSummaryTotal = {};
        this.$scope.hessCategoryLayers.forEach((element) => {
          // console.log(element);
          var name = element.name;
          var summary;
          if (
            _.filter(response.data, {
              hess_color: name,
            })[0]
          ) {
            summary = _.filter(response.data, {
              hess_color: name,
            })[0].count_hess_color;
          } else {
            summary = 0;
          }
          this.$scope.hessSummaryTotal[name] = summary;
        });

        // console.log(this.$scope.hessSummaryTotal);

        this.$scope.hessSummary = this.$scope.hessSummaryTotal;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // Revise below to add Environmental Constraints Summary
  loadHessEnviroSummary() {
    if (this.lookup.getHessEnviroSummary().hasOwnProperty("in_cpad")) {
      this.$scope.hessEnviroSummary = this.lookup.getHessEnviroSummary();
    } else {
      this.$scope.hessEnviroSummary = {
        in_cpad: 0,
        in_floodplain: 0,
        in_landslide: 0,
        in_liquefact: 0,
        in_riparian: 0,
        in_seismic: 0,
        in_habitat: 0,
        in_slr36: 0,
        in_slr77: 0,
        // in_liquefaction: 0,
        // The following value i snot currently a boolean
        fire_haz_class: "",
      };

      for (const key in this.$scope.hessEnviroSummary) {
        // console.log(key);
        this.$http
          .get("/api/data/hess/enviro/" + key)
          .then((response) => {
            console.log("response 6");
            if (response.data[0]) {
              var key_count = key + "_count";
              this.$scope.hessEnviroSummary[key] = response.data[0][key_count];
              // console.log(this.$scope.hessEnviroSummary);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }

      this.lookup.setHessEnviroSummary(this.$scope.hessEnviroSummary);
    }
  }

  // Revise below to add Planning Considerations Summary
  loadHessPlanningSummary() {
    if (this.lookup.getHessPlanningSummary().hasOwnProperty("in_pda")) {
      this.$scope.hessPlanningSummary = this.lookup.getHessPlanningSummary();
    } else {
      this.$scope.hessPlanningSummary = {
        in_pda: 0,
        in_tpa: 0,
        in_ppa: 0,
        in_urban_area: 0,
        in_hra: 0,
        in_gg: 0,
      };

      for (const key in this.$scope.hessPlanningSummary) {
        // console.log(key);
        this.$http
          .get("/api/data/hess/planning/" + key)
          .then((response) => {
            console.log("response 7");
            if (response.data[0]) {
              var key_count = key + "_count";
              this.$scope.hessPlanningSummary[key] =
                response.data[0][key_count];
              // console.log(this.$scope.hessPlanningSummary);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }

      this.lookup.setHessPlanningSummary(this.$scope.hessPlanningSummary);
    }
  }

  updateDashboard() {
    $("#loadingDiv").css("visibility", "visible");
    console.log(this.$scope.jurisdiction);
    // Get list of my sites 
        this.getMyList();
    
    this.$http
      .get("/api/data/admin/dashboard/url/" + this.$scope.jurisdiction)
      .then((response) => {
        console.log(response.data);
        this.loadIframe(response.data[0].dashURL);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getJurisdictions() {
    this.$http
      .get("/api/data/admin/lookup/jurisdictions")
      .then((response) => {
        console.log(this.$scope.user.role);
        console.log(response.data);
        console.log("repsonse 8");
        console.log(response.data[0].jurisdiction.split(","));
        if (this.$scope.user.role === "consultant") {
          var jurisdictions = response.data[0].jurisdiction.split(",");
          var jurisdictionsArray = [];
          jurisdictions.forEach((element) => {
            jurisdictionsArray.push({ jurisdiction: element });
          });
          this.$scope.jurisdictions = jurisdictionsArray;
        } else if (this.$scope.user.role === "admin") {
          this.$scope.jurisdictions = response.data;
        }
        console.log(this.$scope.jurisdictions);
      })
      .catch((err) => {
        console.log(err);
      });
  }
}

export default angular.module('hessApp.dashboard', [uiRouter])
  .config(routes)
  .component('dashboard', {
    template: require('./dashboard.html'),
    controller: DashboardComponent,
    controllerAs: 'dashboardCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/dashboard/dashboard.component.js